export default "__VITE_ASSET__Dwu6q9$O__"